import React, { Suspense } from 'react';
import Loader from '../../../common/Loader/Loader';

const LazyComponent = React.lazy(() => import('./PrintPayslip'));

const SuspenseLoading = () => (
    <Suspense fallback={<Loader />} >
        <LazyComponent />
    </Suspense>
);

export default SuspenseLoading